import { useState, useEffect } from 'react';
import { useChatContext } from '../context/use-chat-context';

export const usePathChangeListener = () => {
  const [path, setPath] = useState(window.location.pathname);
  const { isSuperserveUi } = useChatContext();

  useEffect(() => {
    if (isSuperserveUi) return;

    const handleLocationChange = () => {
      setPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleLocationChange);

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function (...args) {
      originalPushState.apply(this, args);
      handleLocationChange();
    };

    history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      handleLocationChange();
    };

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, [isSuperserveUi]);

  return path;
};
